"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const testimonials = [{
  quote: "The expedition to Tayrona was more than a trip; it was a spiritual reconnection. PS Travel doesn't just book rooms; they curate souls.",
  author: "Eric Diaz",
  role: "Colombia Explorer",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/avatar_alex_w.png"
}, {
  quote: "Waking up in Naxos to a sunrise orchestrated by the PS team was the highlight of my decade. Every detail felt like a personal letter.",
  author: "Mark Valencia, Ph.D.",
  role: "Greece Enthusiast",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/avatar_jamie_t.png"
}, {
  quote: "I've seen the world, but I've never felt the world like this. Their philanthropic mission adds a layer of purpose to every mile traveled.",
  author: "Sarah Jenkins",
  role: "Impact Traveler",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/avatar_sarah_j.png"
}, {
  quote: "From the coffee farms of Quindío to the streets of Cartagena, PS Travel handles the logistics so I can handle the wonder.",
  author: "Jamie Taylor",
  role: "Adventure Seeker",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/avatar_marcus_c.png"
}, {
  quote: "Luxury redefined. It's not about the thread count; it's about the depth of the experience. They truly leave the traveler better.",
  author: "Elena Rodriguez",
  role: "Global Nomad",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/avatar_elena_r.png"
}];
export default function VoicesFromTheTrail() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section data-section-id="28924" id="tales-from-the-journey" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/topographic_map_texture.png)] bg-cover bg-center mix-blend-overlay" />

      <div className="container relative z-10 mx-auto px-4">
        <div className="mb-12 flex flex-col items-center text-center">
          <div className="bg-primary/10 mb-6 flex size-12 items-center justify-center rounded-full">
            <Quote className="text-primary size-6" />
          </div>
          <h2 className="font-serif text-secondary text-3xl font-medium tracking-widest md:text-4xl lg:text-5xl uppercase">
            Tales from the Journey
          </h2>
        </div>

        <Carousel setApi={setApi} opts={{
        align: "center",
        loop: true
      }} className="mx-auto w-full max-w-5xl">
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center px-4 text-center md:px-12">
                  <blockquote className="font-default text-foreground text-2xl italic leading-relaxed md:text-4xl lg:text-5xl lg:leading-tight">
                    &ldquo;{item.quote}&rdquo;
                  </blockquote>

                  <div className="mt-10 flex items-center gap-4">
                    <SafeHydrate><Avatar className="border-secondary size-12 border md:size-14">
                      <AvatarImage src={item.img} alt={item.author} className="object-cover" />
                      <AvatarFallback className="bg-muted text-muted-foreground">
                        {item.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="text-left">
                      <div className="font-mono text-secondary text-base font-semibold md:text-lg">
                        {item.author}
                      </div>
                      <div className="font-mono text-muted-foreground text-xs uppercase tracking-widest md:text-sm">
                        {item.role}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="mt-16 flex items-center justify-center gap-8">
            <Button variant="ghost" size="icon" onClick={() => api?.scrollPrev()} className="hover:bg-primary/10 text-secondary hover:text-primary rounded-full transition-colors" aria-label="Previous testimonial">
              <ArrowLeft className="size-6" />
            </Button>

            <div className="font-mono text-muted-foreground text-lg tracking-[0.2em]">
              <span className="text-secondary">
                {String(current).padStart(2, "0")}
              </span>
              <span className="mx-2 opacity-50">/</span>
              <span>{String(count).padStart(2, "0")}</span>
            </div>

            <Button variant="ghost" size="icon" onClick={() => api?.scrollNext()} className="hover:bg-primary/10 text-secondary hover:text-primary rounded-full transition-colors" aria-label="Next testimonial">
              <ArrowRight className="size-6" />
            </Button>
          </div>
        </Carousel>
      </div>
    </section>;
}